import {inject, observer} from 'mobx-react';
import * as React from 'react';
import {findDOMNode} from 'react-dom';
import {ChatChannel} from '../../models/chatChannelModel';
import {ChatModelType} from '../../models/chatModel/chatModel';
import {styled} from '../../utils';
import CohostClubItem from './private/CohostClubItem';
import GuestChatItem from './private/GuestChatItem';
import UserChatItem from './private/UserChatItem';

export enum KindOfChatType {
  GUEST_CHAT = 'guest_chat',
  ANA_CHAT = 'ana_chat',
  COHOST_CLUB_CHAT = 'cohost_club_chat'
}

interface ChatListProps {
  loadMore: () => void;
  kindOfChat: string;
  filteredResults?: ChatChannel[];
  filtering?: boolean;
  filtered?: boolean;
}

interface WithInjectedProps extends ChatListProps {
  chat: ChatModelType;
}

const Root = styled('ul')({
  display: 'block',
  overflow: 'auto',
  height: '100%',
  listStyle: 'none'
});

@inject('chat')
@observer
export default class ChatList extends React.Component<ChatListProps, {}> {
  private _rootNode: HTMLElement;

  public componentDidMount() {
    const rootNode = findDOMNode(this._rootNode);
    (rootNode as HTMLElement).addEventListener('scroll', this._handleScroll);
  }

  public render() {
    const {
      loaded,
      sortedChannels,
      filterResults,
      filterLoaded
    } = this._withInjectedProps.chat;

    const entries = this.props.filtered ? filterResults : sortedChannels;

    const entriesLoading =
      (this.props.filtered && !filterLoaded) || !(loaded && sortedChannels);

    return (
      <Root innerRef={this._setRootNode}>
        {!entriesLoading
          ? entries.map((channel: ChatChannel, index) => {
              if (this.props.kindOfChat === KindOfChatType.GUEST_CHAT) {
                return this._guestChatItem(channel, index);
              } else if (this.props.kindOfChat === KindOfChatType.ANA_CHAT) {
                return this._anaChatItem(channel, index);
              } else if (
                this.props.kindOfChat === KindOfChatType.COHOST_CLUB_CHAT
              ) {
                return this._cohostClubItem(channel, index);
              }
              return null;
            })
          : null}
      </Root>
    );
  }

  private _setRootNode = (node: HTMLElement) => (this._rootNode = node);

  private _handleScroll = () => {
    if (this._rootNode.scrollTop === this._maxScrollTop) {
      const {loadMore} = this.props;

      if (typeof loadMore === 'function') {
        loadMore();
      }
    }
  };

  private _guestChatItem = (channel: ChatChannel, index: number) => {
    const {currentChannel} = this._withInjectedProps.chat;
    return channel.type.toLowerCase() === 'external' ? (
      <GuestChatItem
        key={index}
        channel={channel}
        isActive={Boolean(currentChannel && currentChannel.id === channel.id)}
      />
    ) : (
      <div>Internal channel</div>
    );
  };

  private _anaChatItem = (channel: ChatChannel, index: number) => {
    const {currentChannel} = this._withInjectedProps.chat;
    return (
      <UserChatItem
        key={index}
        channel={channel}
        isActive={Boolean(currentChannel && currentChannel.id === channel.id)}
      />
    );
  };

  private _cohostClubItem = (channel: ChatChannel, index: number) => {
    const {currentChannel} = this._withInjectedProps.chat;
    return (
      <CohostClubItem
        key={index}
        channel={channel}
        isActive={Boolean(currentChannel && currentChannel.id === channel.id)}
      />
    );
  };

  private get _maxScrollTop() {
    return this._rootNode.scrollHeight - this._rootNode.clientHeight;
  }

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }
}



// WEBPACK FOOTER //
// ./src/containers/ChatList/ChatList.tsx